"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var webAApi_1 = require("../../../../api/webAApi");
var moment = require("moment");
var BonusTemplatePlayerTagsListCtl = /** @class */ (function (_super) {
    __extends(BonusTemplatePlayerTagsListCtl, _super);
    function BonusTemplatePlayerTagsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_app_usr_player_tag_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_usr_player_tag_id; });
        _this.dk_app_usr_player_tag_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_usr_player_tag_title; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTemplatePlayerTagsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BonusTemplatePlayerTagsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "bonus template player tag with id [" + id + "] not found !";
    };
    BonusTemplatePlayerTagsListCtl.prototype.LoadData = function (bonusTemplateId, onDone) {
        var _this = this;
        webAApi_1.ListBonusTemplateRestrictedPlayerTagsGet.exec({
            bonus_template_id: bonusTemplateId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_usr_player_tag_id: resp.list[i].app_usr_player_tag_id,
                    app_usr_player_tag_title: resp.list[i].app_usr_player_tag_title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTemplatePlayerTagsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusTemplateRestrictedPlayerTag.exec({
            data: {
                bonus_template_id: data.bonus_template_id,
                usr_player_tag_id: data.usr_player_tag_id
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                app_usr_player_tag_title: resp.usr_player_tag_title,
                app_usr_player_tag_id: data.usr_player_tag_id
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTemplatePlayerTagsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusTemplatePlayerTagsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusTemplateRestrictedPlayerTag.exec({ data: { bonus_template_player_tag_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusTemplatePlayerTagsListCtl;
}(BaseController_1.BaseController));
exports.BonusTemplatePlayerTagsListCtl = BonusTemplatePlayerTagsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ctl/BonusTemplatePlayerTagsListCtl.ts
// module id = 976
// module chunks = 0